import styled from 'styled-components';

const QuestionsPage = styled('div')`
  overflow: hidden;
`;

export default QuestionsPage;
